export default "__VITE_ASSET__BNG$zNLb__"